import { z } from "zod";

const SUPABASE_FALLBACKS = {
  VITE_SUPABASE_PROJECT_ID: "rfitqikdpuemaclcrdoz",
  VITE_SUPABASE_URL: "https://rfitqikdpuemaclcrdoz.supabase.co",
  VITE_SUPABASE_PUBLISHABLE_KEY:
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJmaXRxaWtkcHVlbWFjbGNyZG96Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzE3MDAzMzMsImV4cCI6MjA4NzI3NjMzM30.RYR77SwYr9RpySEkr61Z2VJwNZu0ChWkV7qWX8_SlEA",
} as const;

const envSchema = z.object({
  VITE_SUPABASE_PROJECT_ID: z.string().min(1, "VITE_SUPABASE_PROJECT_ID is required"),
  VITE_SUPABASE_URL: z.string().url("VITE_SUPABASE_URL must be a valid URL"),
  VITE_SUPABASE_PUBLISHABLE_KEY: z.string().min(1, "VITE_SUPABASE_PUBLISHABLE_KEY is required"),
  VITE_SENTRY_DSN: z.string().optional(),
  VITE_SENTRY_RELEASE: z.string().optional(),
});

export const env = envSchema.parse({
  VITE_SUPABASE_PROJECT_ID:
    import.meta.env.VITE_SUPABASE_PROJECT_ID ?? SUPABASE_FALLBACKS.VITE_SUPABASE_PROJECT_ID,
  VITE_SUPABASE_URL:
    import.meta.env.VITE_SUPABASE_URL ?? SUPABASE_FALLBACKS.VITE_SUPABASE_URL,
  VITE_SUPABASE_PUBLISHABLE_KEY:
    import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ?? SUPABASE_FALLBACKS.VITE_SUPABASE_PUBLISHABLE_KEY,
  VITE_SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
  VITE_SENTRY_RELEASE: import.meta.env.VITE_SENTRY_RELEASE,
});
